// Central configuration for blog posts used by BlogList and BlogLayout
export const BLOG_POSTS = [
  {
    id: "oman-work-permit-rights-rules",
    title: "Working in Oman? Know Your Rights, Duties & Work Permit Rules",
    description: "Planning to work in Oman? Before accepting a job or travelling, it is important to understand your work permit, employment contract, salary, working hours and leave rights.",
    to: "/blogs/oman-work-permit-rights-rules",
    imageKey: "omanWorkPermitRightsRules",
    category: "Labor Rights & Policy",
    readingTime: "8 min read",
    updatedOn: "Oct 2026",
  },
  {
    id: "uae-digital-economy-index-2026",
    title: "UAE Tops Arab Digital Economy Index 2026",
    description: "The UAE has secured the top position in the Arab Digital Economy Index 2026, highlighting its continued progress in digital infrastructure, technology, innovation and digital services.",
    to: "/blogs/uae-digital-economy-index-2026",
    imageKey: "uaeDigitalEconomyIndex",
    category: "Gulf Economy & Jobs",
    readingTime: "7 min read",
    updatedOn: "Oct 2026",
  },
  {
    id: "employers-guide-to-gulf-manpower",
    title: "Employers' Guide to Gulf Manpower Recruitment Services",
    description: "Angel Gulf Jobs provides end-to-end overseas manpower recruitment services for Gulf employers with a transparent recruitment process and verified candidates.",
    to: "/blogs/employers-guide-to-gulf-manpower",
    imageKey: "employersGuide",
    category: "Recruitment & Compliance",
    readingTime: "7 min read",
    updatedOn: "Jan 2026",
  },
  {
    id: "hrd-attestation-for-gulf-employment",
    title: "HRD Attestation for Gulf Employment",
    description: "Complete guide to HRD attestation for Gulf employment. Learn the step-by-step process for Indian degree verification, HRD, MEA, embassy, and MOFA attestation required for UAE, Saudi, Qatar, Kuwait, Oman and Bahrain jobs.",
    to: "/blogs/hrd-attestation-for-gulf-employment",
    imageKey: "hrdAttestation",
    category: "Compliance & Documentation",
    readingTime: "8 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "waqala-system-in-saudi-arabia",
    title: "Waqala System in Saudi Arabia",
    description: "Learn how the Waqala system in Saudi Arabia works and how Angel Gulf Jobs, a licensed overseas recruitment agency, manages authorisation, documentation, and visa procedures for Indian workers.",
    to: "/blogs/waqala-system-in-saudi-arabia",
    imageKey: "waqalaSystem",
    category: "Recruitment & Compliance",
    readingTime: "7 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "saudi-arabia-labour-law-guide-2025",
    title: "Saudi Labour Law:  Complete Guide for Jobs in Saudi Arabia",
    description: "Planning to work in Saudi Arabia? This 2025 Labour Law guide explains Iqama rules, working hours, overtime, leave, salary protection, and expat rights.",
    to: "/blogs/saudi-arabia-labour-law-guide-2025",
    imageKey: "saudiLabourLaw",
    category: "Labour Rights & Policy",
    readingTime: "9 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "wage-protection-system-gcc-countries",
    title: "Wage Protection Systems or WPS in GCC Countries",
    description: "Learn how the Wage Protection System (WPS) in GCC Countries ensures safe, transparent WPS salary payments for workers. Find WPS-compliant jobs in Gulf with Angel Gulf Jobs.",
    to: "/blogs/wage-protection-system-gcc-countries",
    imageKey: "wpsGCC",
    category: "Labour Rights & Policy",
    readingTime: "8 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "understanding-qiwa-platform-guide-for-jobs-in-saudi",
    title: "Understanding Qiwa Platform: A Guide for Jobs in Saudi",
    description: "Learn how Qiwa simplifies overseas employment in Saudi Arabia. Angel Gulf Jobs, trusted overseas job consultants, guide you through work permits, labour protection, digital contracts, and Gulf job opportunities for a safe and secure career in the Gulf.",
    to: "/blogs/understanding-qiwa-platform-guide-for-jobs-in-saudi",
    imageKey: "qiwaSystem",
    category: "Labour Rights & Policy",
    readingTime: "8 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "qatar-visa-centre-guide",
    title: "Qatar Visa Centre (QVC): A Complete Guide",
    description: "Learn the complete Qatar Visa Centre (QVC) process for Indians — biometric enrolment, Qatar visa medical test, documents required, appointment steps, and benefits. Perfect guide for Qatar employment visa applicants.",
    to: "/blogs/qatar-visa-centre-guide",
    imageKey: "qatarVisaCentre",
    category: "Visa Process",
    readingTime: "8 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "trade-testing-program-saudi-arabia",
    title: "Trade Testing Program of Saudi Arabia",
    description: "Learn everything about the Saudi Skill Verification Programme for Indians, SVP test India process, how to pass SVP, Saudi professional verification India requirements, and how Angel Gulf Jobs Saudi recruitment helps Indian workers succeed.",
    to: "/blogs/trade-testing-program-of-saudi-arabia",
    imageKey: "tradeTestingSaudi",
    category: "Skill Verification",
    readingTime: "8 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "ethical-overseas-recruitment",
    title: "Ethical Overseas Recruitment for Gulf Job Seekers",
    description: "Discover ethical overseas recruitment for Gulf jobs with verified, scam-free opportunities. Angel Gulf Jobs ensures transparency, trusted employers, and safe hiring.",
    to: "/blogs/ethical-overseas-recruitment",
    imageKey: "ethicalRecruitment",
    category: "Recruitment & Compliance",
    readingTime: "7 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "gamca-medical-health-checks",
    title: "How GCC is Strengthening Health Checks Through GAMCA Medical",
    description: "Learn how GCC strengthens health checks through the GAMCA Medical Test. Get guidance and verified jobs in Gulf, Dubai, Saudi Arabia, Kuwait, & Oman with Angel Gulf Jobs.",
    to: "/blogs/gamca-medical-health-checks",
    imageKey: "gamcaHealthChecks",
    category: "Medical & Health",
    readingTime: "6 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "average-salary-gcc-countries",
    title: "The Average Salary in GCC Countries",
    description: "Discover the 2025 average salary trends in GCC countries for blue-collar and white-collar workers. Compare salaries in UAE, Saudi Arabia, Qatar, Kuwait, Oman, and Bahrain.",
    to: "/blogs/average-salary-gcc-countries",
    imageKey: "averageSalaryGcc",
    category: "Salary Guide",
    readingTime: "8 min read",
    updatedOn: "Dec 2025",
  },
  {
    id: "connecting-continents-global-talent",
    title:
      "Connecting Continents: How Angel Gulf Jobs is Bridging Global Talent with Opportunity",
    description: "Discover how Angel Gulf Jobs, a trusted overseas manpower consultancy, bridges global talent with verified Gulf employers across the UAE, Qatar, Bahrain, Saudi Arabia, Oman, and Kuwait.",
    to: "/blogs/connecting-continents-global-talent",
    imageKey: "connectingContinents",
    category: "Global Recruitment",
    readingTime: "7 min read",
    updatedOn: "Nov 2025",
  },
  {
    id: "ecr-and-non-ecr-passports",
    title: "ECR and Non-ECR passports",
    description: "Learn the difference between ECR and ECNR passports, who needs emigration clearance, and how Indian jobseekers can safely travel for Gulf employment using the eMigrate portal.",
    to: "/blogs/ecr-and-non-ecr-passports",
    imageKey: "ecrNonEcr",
    category: "Compliance & Documentation",
    readingTime: "7 min read",
    updatedOn: "Nov 2025",
  },
  {
    id: "kafala-system-saudi-arabia",
    title: "The Kafala System: From Control to Reform in Saudi Arabia",
    description: "Learn what the Kafala system is, how it shaped migrant workers' lives in Saudi Arabia and the Gulf, and what its abolition under Vision 2030 means for Indian workers seeking safe, legal overseas employment.",
    to: "/blogs/kafala-system-saudi-arabia",
    imageKey: "kafala",
    category: "Labour Rights & Policy",
    readingTime: "8 min read",
    updatedOn: "Nov 2025",
  },
  {
    id: "economic-diversification-gcc-countries",
    title: "Economic Diversification in GCC Countries",
    description: "Explore how GCC economic diversification is creating new industrial and blue-collar jobs for Indians. Angel Gulf Jobs connects skilled manpower to top Gulf employers.",
    to: "/blogs/economic-diversification-gcc-countries",
    imageKey: "economicDiversificationGCC",
    category: "Gulf Economy & Jobs",
    readingTime: "7 min read",
    updatedOn: "Nov 2025",
  },
  {
    id: "apostille-attestation-gulf-document-verification",
    title: "Apostille Attestation for Gulf document verification",
    description: "Complete guide to Apostille Attestation for Gulf countries. Learn MEA, e-Sanad, embassy and MOFA attestation steps for UAE, Saudi, Qatar, Kuwait, Bahrain & Oman. Includes document requirements, process, timelines and Gulf employment verification.",
    to: "/blogs/apostille-attestation-gulf-document-verification",
    imageKey: "apostilleAttestation",
    category: "Compliance & Documentation",
    readingTime: "7 min read",
    updatedOn: "Nov 2025",
  },
  {
    id: "avoid-gulf-job-scams",
    title: "Avoid Gulf Job Scams & Choose Legit Gulf Job Agencies",
    description: "Learn how to identify fake Gulf job offers, avoid recruitment scams, and choose legit Gulf job agencies. Find verified Gulf jobs for Indians with Angel Gulf Jobs.",
    to: "/blogs/avoid-gulf-job-scams",
    imageKey: "fakeJob",
    category: "Safety & Compliance",
    readingTime: "8 min read",
    updatedOn: "Oct 2025",
  },
  {
    id: "gcc-work-permit-process-for-employment-visa",
    title: "GCC work permit process for employment visa",
    description:
      "Complete guide to GCC work permit and employment visa processes across UAE, Saudi Arabia, Qatar, Oman, Bahrain, and Kuwait. Learn steps, requirements, and employer duties.",
    to: "/blogs/gcc-work-permit-process-for-employment-visa",
    imageKey: "gccWorkPermitVisa",
    category: "Visa Process",
    readingTime: "10 min read",
    updatedOn: "Oct 2025",
  },
  {
    id: "saudi-skill-based-work-permit-system",
    title: "Saudi Skill-Based Work Permit System",
    description:
      "Explore Saudi Arabia’s new skill-based work permit system for foreign workers. Learn the 2025 requirements, classification levels, Qiwa process & Vision 2030 reforms.",
    to: "/blogs/saudi-skill-based-work-permit-system",
    imageKey: "saudiSkillBasedWorkPermit",
    category: "Labour Rights & Policy",
    readingTime: "9 min read",
    updatedOn: "Oct 2025",
  }
];